import React, { Component } from "react";
import {
  DetailsList,
  DatePicker,
  IDatePickerStrings,
  Checkbox,
  Label,
  Text,
  TextField,
} from "office-ui-fabric-react";

import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";
import { MatterItemDateText } from "./Vertical-Timeline/CustomFuntion";

import { EventEmitter } from "./events";

interface IFilters {
  items: [];
  column: [];
  tempFilter: IFilterType[];
  selectedItems: any[];
}

const DayPickerStrings: IDatePickerStrings = {
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],

  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],

  shortDays: ["S", "M", "T", "W", "T", "F", "S"],

  goToToday: "Go to today",
  prevMonthAriaLabel: "Go to previous month",
  nextMonthAriaLabel: "Go to next month",
  prevYearAriaLabel: "Go to previous year",
  nextYearAriaLabel: "Go to next year",
  closeButtonAriaLabel: "Close date picker",
};

const controlClass = mergeStyleSets({
  control: {
    margin: "0 0 1vh 0",
  },
});

interface IFilterType {
  column: string;
  values: any[];
}

class Filters extends Component<IFilters> {
  private filterValues: any[];
  constructor(props: any) {
    super(props);

    this.state = {
      items: [],
      filteredItems: [],
      selectedItems: [],
      columnName: "",
      columnKey: "",
      isDateFilter: false,
      search: "",
      startDate: undefined,
      endDate: undefined,
    };

    this.filterValues = [];

    this.onfilterSelect = this.onfilterSelect.bind(this);
  }

  componentDidMount() {
    this.setFilteredItems();
    this.setSelectedItems();

    if (this.props.column.data === "date") {
      if (this.props.tempFilter.values.length > 0) {
        this.setState({
          startDate:
            this.props.tempFilter.values[0] != undefined
              ? this.props.tempFilter.values[0]
              : undefined,
          endDate:
            this.props.tempFilter.values[1] != undefined
              ? this.props.tempFilter.values[1]
              : undefined,
        });
      }
    }

    this.setState({
      isDateFilter: this.props.column.data === "date" ? true : false,
      columnKey: this.props.column.key,
      items: this.props.items,
    });
  }

  setFilteredItems() {
    let items = this.props.items;
    let newList: string[] = [];
    items.map((rec: any) => {
      const rawItem = rec[this.props.column.key];
      const item = rawItem == null ? "" : String(rawItem);
      if (item.length > 0 && newList.indexOf(item) < 0) {
        newList.push(item);
      }
    });
    newList.sort((left: string, right: string) => left.localeCompare(right));
    this.setState({
      filteredItems: newList,
    });
  }

  setSelectedItems() {
    if (this.props.column.data != "date") {
      if (this.props.selectedItems.column == this.props.column.key) {
        const selectedItems = (this.props.selectedItems.values || []).slice();
        this.filterValues = selectedItems;
        this.setState({
          selectedItems: selectedItems,
        });
      }
    }
  }

  setDefaultItems(item: any) {
    if (this.state.selectedItems.indexOf(item) < 0) {
      return false;
    } else {
      return true;
    }
  }

  onfilterSelect(ev: React.FormEvent<HTMLElement>) {
    const target = ev.target as HTMLInputElement;
    let filterValues = this.filterValues.slice();

    if (target.checked) {
      if (filterValues.indexOf(target.value) < 0) {
        filterValues.push(target.value);
      }
    } else {
      filterValues = filterValues.filter((value: any) => value !== target.value);
    }

    this.filterValues = filterValues;
    this.setState({
      selectedItems: filterValues,
    });

    let param = {
      column: this.state.columnKey,
      values: filterValues.slice(),
    };

    EventEmitter.dispatch("apply-filters", param);
  }

  _onFormatDate = (date: Date) => {
    return MatterItemDateText(date);
  };

  onSelectFromDate(date: Date) {
    let _filter = this.filterValues;
    var self = this;

    _filter[0] = date;

    this.setState({ startDate: date });
    if (this.state.endDate != undefined) {
      _filter[1] = this.state.endDate;
    }

    let param = {
      column: this.state.columnKey,
      values: this.filterValues,
    };

    EventEmitter.dispatch("apply-filters", param);
  }

  onSelectToDate(date: Date) {
    let _filter = this.filterValues;
    var self = this;

    this.setState({ endDate: date });

    if (this.state.startDate != undefined) {
      _filter[0] = this.state.startDate;
    }

    _filter[1] = date;

    let param = {
      column: this.state.columnKey,
      values: this.filterValues,
    };

    EventEmitter.dispatch("apply-filters", param);
  }

  _onSearchChanged = (ev, value) => {
    this.setState({
      search: value,
    });
  };

  _itemList = () => {
    return (
      <div>
        <div>
          <TextField
            autoComplete="off"
            className="search-filter"
            type="text"
            value={this.state.search}
            onChange={this._onSearchChanged}
          />
        </div>
        {this.state.filteredItems.map((rec: any) => {
            var returnValue = [];
            const filterItem = String(rec);

            if (filterItem.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1) {
                    returnValue.push(
                        <div key={filterItem}>
                            <label className="label-filter-checkbox">
                                <input
                                    type="checkbox"
                                    value={filterItem}
                                    onChange={this.onfilterSelect}
                                    defaultChecked={this.setDefaultItems(filterItem)}
                                />
                                <span className="filter-item">{filterItem}</span>
                            </label>
                            <hr className="line-item" />
                        </div>,
                    );
            }
          return returnValue;
        })}
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.state.isDateFilter ? (
          <div>
            <DatePicker
              className={controlClass.control}
              strings={DayPickerStrings}
              showWeekNumbers={false}
              firstWeekOfYear={1}
              showMonthPickerAsOverlay={true}
              placeholder="Select start date..."
              ariaLabel="Select start date"
              onSelectDate={(item) => {
                this.onSelectFromDate(item);
              }}
              maxDate={
                this.state.endDate != undefined ? this.state.endDate : null
              }
              value={this.state.startDate}
              formatDate={this._onFormatDate}
            />
            <DatePicker
              strings={DayPickerStrings}
              showWeekNumbers={false}
              firstWeekOfYear={1}
              showMonthPickerAsOverlay={true}
              placeholder="Select end date..."
              ariaLabel="Select end date"
              onSelectDate={(item) => {
                this.onSelectToDate(item);
              }}
              minDate={
                this.state.startDate != undefined ? this.state.startDate : null
              }
              value={this.state.endDate}
              formatDate={this._onFormatDate}
            />
          </div>
        ) : (
          this._itemList()
        )}
      </div>
    );
  }
}

export default Filters;
